import { RouteModule } from '#/horizon/components/RouteModule';
import type { LoaderDataWithOverrideLocale } from '#/horizon/useMatchesOverrideLocale';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { salariesExploreRoute } from '#/modules/salaries/routing/salaries.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { SalaryReportLoadable } from './SalaryReportLoadable';

export const handle = {
  noAds: true,
  defaultSearchType: 'JOB',
  hideFooterDivider: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof salariesExploreRoute>,
) {
  await SalaryReportLoadable.load();

  return {
    overrideLocale: I18nLocale.EN,
  } satisfies LoaderDataWithOverrideLocale;
}

export default function SalaryReportHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RouteModule title="Explore Nonprofit Salaries">
      <SalaryReportLoadable />
    </RouteModule>
  );
}
